import { render } from "./Lockers.vue?vue&type=template&id=26d8042a"
import script from "./Lockers.vue?vue&type=script&lang=js"
export * from "./Lockers.vue?vue&type=script&lang=js"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__